import { Share2 } from "lucide-react";
import { toast } from "sonner";

export const Logo = ({ size = 36, className = "", testId = "brand-logo" }) => (
  <img
    src="/logo.png"
    alt="Random Rider logo"
    width={size}
    height={size}
    className={`rounded-full shrink-0 ${className}`}
    data-testid={testId}
  />
);

export const shareUrl = (kind, slug) =>
  `${process.env.REACT_APP_BACKEND_URL}/api/share/${kind}${slug ? `/${slug}` : ""}`;

export const shareLink = async (kind, slug, title, onCopied) => {
  const url = shareUrl(kind, slug);
  if (navigator.share) {
    try { await navigator.share({ title, url }); return; } catch { /* cancelled */ }
  }
  await navigator.clipboard.writeText(url);
  onCopied?.();
};

export const ShareButton = ({ kind, slug, title, testId, className = "", label = "" }) => (
  <button
    type="button"
    onClick={() => shareLink(kind, slug, title, () => toast.success("Share link copied — paste it in WhatsApp"))}
    title="Share as WhatsApp card"
    aria-label={`Share ${title}`}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-1.5 transition-colors ${className}`}
  >
    <Share2 size={14} /> {label}
  </button>
);
